var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcrobat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1781_7992",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H50H0ZM50 50.5H0H50ZM0 50.5V0.5V50.5ZM26 0.5C39.8071 0.5 51 11.6929 51 25.5C51 39.3071 39.8071 50.5 26 50.5H25C38.2548 50.5 49 39.3071 49 25.5C49 11.6929 38.2548 0.5 25 0.5H26Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1781_7992)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1781_7992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8804 27.6628C32.1338 27.6628 29.9479 27.9783 29.2328 28.0894C26.273 24.8881 25.4309 23.0685 25.2415 22.5834C25.4982 21.9003 26.3913 19.3053 26.5182 15.9726C26.5808 14.304 26.2405 13.0572 25.5064 12.2668C24.7737 11.4777 23.8867 11.4163 23.6323 11.4163C22.7405 11.4163 21.2444 11.8834 21.2444 15.0113C21.2444 17.7252 22.4661 20.605 22.8038 21.3491C21.0245 26.7149 19.1143 30.388 18.7087 31.1434C11.5591 33.9315 11 36.6271 11 37.3912C11 38.7641 11.9441 39.5837 13.5253 39.5837C17.3672 39.5837 20.8732 32.9033 21.4529 31.7433C24.1815 30.6172 27.8336 29.9197 28.762 29.7533C31.4251 32.3807 34.505 33.0818 35.784 33.0818C36.7463 33.0818 38.9999 33.0818 38.9999 30.682C39 28.4534 36.2422 27.6628 33.8804 27.6628ZM33.6953 29.2382C35.7704 29.2382 36.3189 29.949 36.3189 30.3248C36.3189 30.5606 36.2324 31.3301 35.1201 31.3301C34.1227 31.3301 32.4006 30.733 30.7062 29.4376C31.4128 29.3414 32.4584 29.2382 33.6953 29.2382ZM23.5234 12.9434C23.7126 12.9434 23.8372 13.0064 23.9399 13.1539C24.5367 14.0116 24.0555 16.8143 23.4698 19.0076C22.9043 17.127 22.48 14.2414 23.077 13.2262C23.1937 13.0281 23.3271 12.9434 23.5234 12.9434ZM22.5156 29.7309C23.2669 28.159 24.109 25.868 24.5676 24.5722C25.4855 26.1634 26.72 27.6407 27.434 28.4417C25.2109 28.9271 23.5289 29.412 22.5156 29.7309ZM12.4924 37.6009C12.4429 37.5401 12.4356 37.4119 12.4729 37.258C12.5511 36.9356 13.1489 35.3371 17.4723 33.3341C16.8533 34.344 15.8855 35.7871 14.8223 36.8651C14.0739 37.5907 13.4911 37.9586 13.0902 37.9586C12.9467 37.9586 12.7491 37.9181 12.4924 37.6009Z",
    fill: "#CC0707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1781_7992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcrobat);
export default __webpack_public_path__ + "static/media/acrobat.f3d9ae47b975763b35fb4a4f6eb9a8ff.svg";
export { ForwardRef as ReactComponent };